import {
	CmChangePicture,
	CmEpisodicItemPicture,
	EpisodicCharacterPicture,
	HaLookPicture,
	MuLookPicture,
	PictureScene,
	PrEpisodicPropPicture,
	SetPicture,
	SetPiecePicture,
} from '../..';
import Change from '../changes/change.entity';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import HaChange from '../ha-changes/ha-change.entity';
import MuChange from '../mu-changes/mu-change.entity';
import Scene from '../scenes/scene.entity';
import SetPiece from '../set-pieces/set-piece.entity';
import Set from '../sets/set.entity';
import { SosListResponse } from '../sos-response';

export interface PhotoTagListResponse extends SosListResponse {
	listed: {
		Change?: Change[];
		CmChangePicture?: CmChangePicture[];
		CmEpisodicItemPicture?: CmEpisodicItemPicture[];
		EpisodicCharacterPicture?: EpisodicCharacterPicture[];
		EpisodicCharacter?: EpisodicCharacter[];
		EpisodicItem?: EpisodicItem[];
		EpisodicProp?: EpisodicProp[];
		HaChange?: HaChange[];
		HaLookPicture?: HaLookPicture[];
		MuChange?: MuChange[];
		MuLookPicture?: MuLookPicture[];
		PictureScene?: PictureScene[];
		PrEpisodicPropPicture?: PrEpisodicPropPicture[];
		Scene?: Scene[];
		Set?: Set[];
		SetPiece?: SetPiece[];
		SetPicture?: SetPicture[];
		SetPiecePicture?: SetPiecePicture[];
	};
}
